/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {CompoApiService} from './compo-api.service';
import {ApiResponse} from '../interfaces/ApiResponse';
import {BaseService} from './base.service';
import {catchError} from 'rxjs/operators';
import { EventTransport } from '../interfaces/EventTransport';

@Injectable({
  providedIn: 'root'
})

export class EventTransportService extends BaseService {

  constructor(private readonly apiService: CompoApiService) {
    super();
  }

  getAll(): Observable<ApiResponse<EventTransport[]>> {
    const url = '/cabinet/event-transport/list';
    return this.apiService.get<EventTransport[]>(url).pipe(catchError(err => this.handleError(err)));
  }
}
